// import { getHotelTypes, getHotelAmenities, getHotelThemes, getRoomAmenities } from 'b2b-common/services/api/hotel'
import {
  getDeparturePoints,
  getDestinationPoints,
  getDates,
  getSearchParams,
  getSearchResults,
  search
} from 'b2b-common/services/api/bus'

export default {
  initDataLoaded: false,

  departures: [],
  destinations: [],
  departureDates: [],
  returnDates: [],

  distribution: null,

  params: {
    pax: { adults: 2, childAges: [] },
    done: false
  },
  results: [],

  async init () {
    if (this.initDataLoaded) return Promise.resolve(true)
    let initialRequests = [
      getDestinationPoints({ dc: this.distribution }),
      getSearchParams({ dc: this.distribution }),
      getSearchResults({ dc: this.distribution })
    ]
    let res = await Promise.all(initialRequests)
    this.destinations = res[0]
    this.params = res[1]
    this.results = res[2]

    if (this.params.to) {
      initialRequests = [
        getDeparturePoints({
          destination: this.params.to,
          dc: this.distribution
        })
      ]

      initialRequests.push(getDates({
        type: 'in',
        to: this.params.from,
        from: this.params.to,
        dc: this.distribution
      }))
      if (this.params.route_type === 'return' || this.params.route_type === 'out') {
        initialRequests.push(getDates({
          type: 'out',
          from: this.params.from,
          to: this.params.to,
          dc: this.distribution
        }))
      }

      res = await Promise.all(initialRequests)

      this.departures = res[0]
      this.returnDates = res[1]
      if (res.length > 2) this.departureDates = res[2]
    }

    this.initDataLoaded = true
    return true
  },

  async search (params) {
    const pCopy = { ...params }
    if (pCopy.route_type === 'in') {
      pCopy.date_from = pCopy.date_to
      pCopy.date_to = null
    }
    const res = await search(pCopy)
    const newParams = await getSearchParams({ dc: this.distribution })
    this.params = newParams
    this.results = res
    return this.results
  }

}
